/**
 * Validación del envío del widget. Pura, sin DOM: es lo que cierra el gap más grande del mockup,
 * donde el botón siempre decía "¡Recibido, gracias!" aunque el formulario estuviera vacío.
 */

/** Debajo de esto pedimos más detalle, pero NO bloqueamos: "no anda" es un reporte legítimo. */
const NUDGE_MIN_CHARS = 15;

/**
 * @returns {{ok: boolean, errorKey: ?string, focusTarget: ?string}}
 *   `focusTarget` es 'type' | 'text' — a quién mandarle el foco cuando el usuario clickea Enviar
 *   con el formulario inválido. Un botón deshabilitado que no explica por qué lo está es peor.
 */
export function validateSubmission({type, text, hasAudio, attachmentsCount}) {
    if (!type) {
        return {ok: false, errorKey: 'feedback.error.no_type', focusTarget: 'type'};
    }
    const trimmed = (text || '').trim();
    if (!trimmed && !hasAudio) {
        // Sólo capturas no alcanza: una imagen sin una línea de contexto es inaccionable para
        // quien la triagea. Mismo criterio que el backend.
        return {ok: false, errorKey: 'feedback.error.no_content', focusTarget: 'text'};
    }
    return {ok: true, errorKey: null, focusTarget: null};
}

/**
 * Sugerencia blanda: se muestra debajo del textarea pero NO impide enviar.
 *
 * Bloquear por longitud es paternalista y pierde reportes reales — a veces el título del feedback
 * ES "no carga".
 */
export function shouldNudgeForMoreDetail({text, hasAudio, attachmentsCount}) {
    if (hasAudio || attachmentsCount > 0) return false;
    const trimmed = (text || '').trim();
    return trimmed.length > 0 && trimmed.length < NUDGE_MIN_CHARS;
}

/** Mapea la respuesta del backend a la key del mensaje que ve el usuario. */
export function errorKeyForResponse(response) {
    const status = response && response.status;
    const code = response && response.error_code;
    if (status === 'NETWORK_ERROR') return 'feedback.error.network';
    if (code === 'RATE_LIMITED' || status === 429) return 'feedback.error.rate_limited';
    if (code === 'TOO_LARGE' || status === 413) return 'feedback.error.too_large';
    return 'feedback.error.generic';
}
